import React from 'react';
import { Button } from 'ctm-components';
import { pageContext } from 'ctm-util-functions';
import styles from './technical_error.css';

const TechnicalError = () => {
    const handleClick = async (event) => {
        if  (pageContext.getVertical() === 'car-insurance') {
            pageContext.getProps().browserHistory.push('/car-insurance/journey/start');
        } else if (pageContext.getVertical() === 'home-contents-insurance') {
            pageContext.getProps().browserHistory.push('/home-contents-insurance/journey/start');
        }
    };
    return (
        <div className={styles.errorContainer}>
            <div className={styles.errorTitle}>We’ve experienced a technical error.</div>
            <div className={styles.errorMessage }>Please try again later or start a new quote.</div>
            <div className={styles.errorButtonContainer}>
                <Button
                    id="prefillVerify.errorStartNewQuoteButton"
                    className={styles.errorButton}
                    UIComponent='btn_secondary_xlarge_semi_rounded'
                    icon="ctm_arrow_right"
                    label='Start New Quote'
                    onClick={(event) => handleClick(event)}
                />
            </div>
        </div>
    );
};

export { TechnicalError };
